import * as yup from "yup";
import { IndicatorFieldType } from "./interface";

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	iqb001Descricao: yup.string().required(translate("A descrição do campo é requerido")),
	iqb001Label: yup.string().required(translate("O rótulo do campo é requerido")),
	iqb001Casasdecimais: yup.number().required(translate("O número de casas decimais é requerido")).typeError(translate("Número de casas decimais está incorreto")),
	iqb001Codigo: yup.string().nullable(),
	iqtbb002: yup.array().of(origins(translate))
});

const origins = (translate: Function) => yup.object().shape({
	iqb002Dtvalini:yup.date()
		.required(translate("Data inicial da validade é requerida"))
		.typeError(translate("Data inicial com data inválida"))
		.nullable(),
	iqb002Dtvalfim:yup.date()
		.required(translate("Data final da validade é requerida"))
		.typeError(translate("Data final com data inválida"))
		.nullable()
		.when("iqb002Dtvalini",(initialDate,schema) => initialDate ? schema.min(initialDate,translate("Data final não pode ser menor que a inicial")):schema),
	iqb002Formula: yup.string()
		.when("iqb002Tipo",(type,schema) => 
			type === IndicatorFieldType.FORMULA ? 
				schema.required(translate("A fórmula é requerida"))
					.test("ValidateFormula",translate("A fórmula está inválida"),validateFormula)
				:
				schema.nullable()),
	iqb002Descricao:yup.string().nullable(),
	iqb002Tipo: yup.string()
		.required(translate("Tipo é requerido")),
	iqb002Efa020Id:yup.number()
		.when("iqb002Tipo",(type,schema) => type === IndicatorFieldType.INTEGRATION || type === IndicatorFieldType.WEBSERVICE ? schema.required(translate("Origem de dados é obrigatória")) : schema.nullable()),
	iqb002Wstiporet:yup.string()
		.when("iqb002Tipo",(type,schema) => type === IndicatorFieldType.WEBSERVICE  ? schema.required(translate("Formato dos dados é obrigatório")) : schema.nullable()),
	iqb002Wspathret:yup.string().nullable()
});

const validateFormula = (value:string|any):boolean => {
	try {
		// verifica se existe um bin e um número lado a lado, sem operador entre eles.
		if (/(\])(\s*)([0-9])/g.test(value)) {
			return false;
		}
		if (/([0-9])(\s*)(\[)/g.test(value)) {
			return false;
		}
		// verifica se exite bind sem valor dentro
		if (/(\[\s*])/g.test(value)) {
			return false;
		}
		// verifica se existem binds lado a lado, sem operador entre eles
		let val = value.replace(/\s\n|\s/g, "");
		if (val.includes("][")) {
			return false;
		}
		// verifica se, após trocar os binds, existem binds inválidos
		val = val.replace(/\[(.*?)\]/g, "1");
		if (val.includes("[") || val.includes("]")) {
			return false;
		}
		// verifica se a expressão é uma expressão matemática válida
		// eslint-disable-next-line no-eval
		if (Number.isNaN(parseFloat(eval(val)))) {
			return false;
		}
		return true;
	} catch (e) {
		return false;
	}
};

export default  addAndChangeSchema;
